import { render } from "./HighlightMenu.vue?vue&type=template&id=3630cb06&scoped=true&ts=true&lang=html"
import script from "./HighlightMenu.vue?vue&type=script&lang=ts"
export * from "./HighlightMenu.vue?vue&type=script&lang=ts"

import "./HighlightMenu.vue?vue&type=style&index=0&id=3630cb06&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3630cb06"]])

export default __exports__